@if (canInstallNativeApp) {
<div class="text-center text-md-left">
  <a class="btn btn-primary" [attr.data-e2e]="e2e + '-button'" [href]="url"> {{ i18nPath + '.title' | translate }} </a>
</div>
} @else {
<div class="border p-1 d-flex align-items-center">
  <img [alt]="url" [attr.data-e2e]="e2e + '-image'" [src]="url | qrCode:96 | async" />

  <div class="ml-1">
    <div class="d-flex align-items-center mb-1">
      <img alt="" aria-hidden="true" class="mr-1" [src]="logoPath" width="32px" />
      <p class="h4 text-primary m-0 p-0">{{ i18nPath + '.title' | translate }}</p>
    </div>

    <p class="font-weight-bold m-0 p-0">{{ i18nPath + '.description' | translate }}</p>
  </div>
</div>
}
